import { Empty } from 'antd';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { getAccess, log } from 'utils';
import { deleteInformation } from 'state/actions/information';
// import { regexInput } from 'utils/regex';
// import Table from 'components/Table';
import _ from 'underscore';
import { EmptyIcon } from 'assets/icon/bigicon';
import { FilterIcon } from 'assets/icon';
import {
  createInformationCategory,
  deleteInformationCategory,
  modifyInformationCategory,
  setInformationCategory,
} from 'state/actions/informationCategories';
import ModalDelete from 'components/ModalDelete';
import Cards from 'design-components/Cards';
import CategoryDropdown from 'components/CategoryDropdown';
import './PostingPage.scss';
import './PostingPage.css';
import { setInfoCategory } from '../../state/actions/breadcrumb';
import { deleteWebContents, fetchWebContents } from 'state/actions/webContents';
import AddPostingPage from 'pages/AddPostingPage';

const PostingPage = ({ history }) => {
  const { siteId, siteName } = useParams();

  const {
    webContentData,
    informationCategories,
    selectedCategory,
    loading,
    userData,
    role,
    category,
  } = useSelector(
    (state) => ({
      webContentData: state.webContents.list,
      selectedCategory: state.breadcrumb.infoCategory,
      informationCategories: state.informationCategories.list,
      error: state.webContents.error,
      loading: state.webContents.loading,
      deleted: state.webContents.deleted,
      userData: state.auth.userData,
      role: state.auth.userData.role,
      category: state.informationCategories.category,
    }),
    shallowEqual
  );

  if (webContentData) {
    log(webContentData, '<<< web content data');
  }

  const [deleteModal, setDeleteModal] = useState({
    information: null,
    isOpen: false,
  });

  const dispatch = useDispatch();

  const [search, setSearch] = useState();
  // const [isEditing, setIsEditing] = useState(false);
  // const [visible, setVisible] = useState(false);
  // const [searchError, setSearchError] = useState(null);
  const [tempSelectedCategory, setTempSelectedCategory] =
    useState(selectedCategory);
  const [playlistOpen, setPlaylistOpen] = useState(false);
  // const [minValue, setMinValue] = useState(0);
  // const [maxValue, setMaxValue] = useState(16);
  const [modalCategory, setModalCategory] = useState(false);
  const [dragDropElement, setDragDropElement] = useState({
    dragged: '',
    enter: '',
  });
  const [modalDeleteCategory, setModalDeleteCategory] = useState({
    show: false,
    category: null,
  });

  const [access, setAccess] = useState(null);

  const [showAddPosting, setShowAddPosting] = useState(false);

  const uid = userData.id;

  useEffect(() => {
    if (userData?.roleAccess) {
      setAccess(getAccess(userData, 'post', siteId));
    }
  }, [userData, siteId]);

  const onRemoveButtonClickHandler = (information) => {
    setDeleteModal({
      information,
      isOpen: true,
    });
  };

  const onCloseModalHandler = () => {
    setDeleteModal({ information: null, isOpen: false });
  };

  const onDeleteInformationHandler = () => {
    dispatch(
      deleteWebContents({ id: deleteModal.information, siteId }, () => {
        onCloseModalHandler();
      })
    );
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const filteredData = search
    ? webContentData.filter((el) => {
        const clonedElem = { ...el };
        return clonedElem.name.toLowerCase().includes(search.toLowerCase());
      })
    : webContentData;

  const handleEdit = (data) => {
    setShowAddPosting(true);
    showSelectedPostData(data);
  };

  const [selectedPostData, showSelectedPostData] = useState([]);

  useEffect(() => {
    dispatch(fetchWebContents({ siteId }));
  }, [siteId]);

  return showAddPosting ? (
    <AddPostingPage
      predefinedData={selectedPostData}
      closeAddPosting={() => {
        showSelectedPostData([]);
        setShowAddPosting(false);
      }}
    />
  ) : (
    <div className="posting-page-library">
      <ModalDelete
        isVisible={deleteModal.isOpen}
        onOk={onDeleteInformationHandler}
        onCancel={onCloseModalHandler}
        title="Delete Post"
        subtitle={deleteModal.information ? deleteModal.information.name : ''}
        loading={loading}
      />

      <div className="posting-page-header">
        <div className="posting-page-header-left">
          <div className="searchbar-wrapper">
            <div className="searchbar">
              <i className="feather-search" />
              <input
                placeholder="Search"
                className="search-input"
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
        <div className="actions__wrapper">
          {role !== 'superadmin' ? (
            access &&
            access.create && (
              <div
                className="btn-primary"
                onClick={() => {
                  setShowAddPosting(true);
                  showSelectedPostData([]);
                }}
              >
                <i className="feather-plus mr-2" />
                Add Post
              </div>
            )
          ) : (
            <div
              className="btn-primary"
              onClick={() => {
                setShowAddPosting(true);
                showSelectedPostData([]);
              }}
            >
              <i className="feather-plus mr-2" />
              Add Post
            </div>
          )}
        </div>
      </div>

      <div className="posting-page-content-wrapper">
        <div className="posting-page-content">
          {loading ? (
            <span>Loading...</span>
          ) : (
            <div className="posting-page-list-content">
              {webContentData?.length > 0 && filteredData.length > 0 ? (
                _.chunk(filteredData, 3).map((chunk, index) => {
                  return (
                    <div className="posting-page-list-chunk" key={index}>
                      {chunk.map((content) => {
                        return (
                          <div
                            key={content._id}
                            data-id={content._id}
                            className={`posting-page-list ${
                              dragDropElement.dragged === content._id
                                ? 'dragged'
                                : ''
                            } ${
                              dragDropElement.enter === content._id
                                ? 'entered'
                                : ''
                            }`}
                            draggable
                            onDragStart={() =>
                              setDragDropElement({
                                ...dragDropElement,
                                dragged: content._id,
                              })
                            }
                            onDragEnd={() =>
                              setDragDropElement({
                                ...dragDropElement,
                                dragged: '',
                              })
                            }
                            onDragEnter={() => {
                              setDragDropElement({
                                ...dragDropElement,
                                enter: content._id,
                              });
                            }}
                            onDragOver={(e) => {
                              e.preventDefault();
                              return false;
                            }}
                            onDrop={(e) => {
                              // e.stopPropagation();
                              // const findInfo = informationList.find(
                              //   (info) => info._id === dragDropElement.dragged
                              // );
                              // const sourceSequence = findInfo.sequence;
                              // const newInfo = [...informationList];
                              // const findSource = newInfo.find(
                              //   (x) => x._id === findInfo._id
                              // );
                              // if (findSource) {
                              //   findSource.sequence = information.sequence;
                              // }
                              // const findTarget = newInfo.find(
                              //   (x) => x._id === information._id
                              // );
                              // if (findTarget) {
                              //   findTarget.sequence = sourceSequence;
                              // }
                              // dispatch(
                              //   bulkInformation({
                              //     data: _.sortBy(newInfo, 'sequence'),
                              //     siteId,
                              //   })
                              // );
                              // setDragDropElement({
                              //   dragged: '',
                              //   enter: '',
                              // });
                            }}
                          >
                            <Cards
                              data={content}
                              type="content"
                              isShowinformation
                              isDelete={true}
                              editAction={() => handleEdit(content)}
                              deleteAction={() =>
                                onRemoveButtonClickHandler(content._id)
                              }
                            />
                          </div>
                        );
                      })}
                      {chunk.length < 2 && (
                        <div className="posting-page-list-empty" />
                      )}
                      {chunk.length < 3 && (
                        <div className="posting-page-list-empty" />
                      )}
                    </div>
                  );
                })
              ) : (
                <div className="posting-page-empty">
                  <Empty image={<EmptyIcon />} description="No Post" />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PostingPage;
